'use client'

import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import { useEffect } from 'react'
import { useSearchParams, usePathname } from 'next/navigation'
import { useMount } from 'ahooks'
import { ChevronUpIcon } from '@heroicons/react/20/solid'
import { getCookie } from 'cookies-next'
import Schema from 'schema-dts'
import { JsonLd } from 'react-schemaorg'

import { useGlobalStore } from '@/store/provider'
import { defaultQuery } from '@/settings'
import { cruzSocket } from '@/lib'

export function RootLayoutClient({ children }: { children: React.ReactNode }) {
  const { setSpottedFilter, setVehicleFilter, scrollTopOver } = useGlobalStore((state) => state)
  const pathname = usePathname()

  useEffect(() => {
    const sPathname = _.split(pathname, '/')
    let xPathname = ''
    if (sPathname[1] === 'vehicle') {
      xPathname = '/vehicle-detail'
    } else if (sPathname[1] === 'spotted' && sPathname.length > 2) {
      xPathname = '/spotted-detail'
    } else {
      xPathname = _.chain(sPathname).take(3).join('/').value()
    }
    if (cruzSocket.socket) {
      cruzSocket.socket.emit('pathChanged', xPathname)
    } else {
      cruzSocket.init(xPathname)
    }
  }, [pathname])

  const params = useSearchParams()
  useMount(() => {
    // spotted
    const spottedFilter = getCookie('spotted_filter') as string || '{}'
    setSpottedFilter({
      ...defaultQuery.spotted,
      ...JSON.parse(spottedFilter),
    })
    // vehicle
    const vehicleFilter = getCookie('vehicle_filter') as string || '{}'
    setVehicleFilter({
      ...defaultQuery.vehicle,
      ...JSON.parse(vehicleFilter),
      ..._.pick(Object.fromEntries(params), ['zip_code', 'radius']),
    })
  })

  const BtnGoTop = () => {
    return (
      <button type='button'
        className={twMerge('btn-float group bottom-[120px] bg-zinc-800 text-white dark:bg-zinc-300 dark:text-black', !scrollTopOver && 'hidden')}
        onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }) }}
        aria-label='Go to Top'
      >
        <span className='flex items-center gap-x-1'>
          <ChevronUpIcon className='size-7 group-hover:scale-125' />
          <span className='hidden group-hover:block pr-2'>Go to Top</span>
        </span>
      </button>
    )
  }

  const defaultSchema: Schema.WebSite & { "@context": "https://schema.org" } = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Cruz.com',
    description: 'Shop our collection of for sale, open to offers to find your next vehicle that fits your life',
    url: 'https://www.cruz.com',
  }

  return (
    <div className='min-h-screen flex flex-col bg-zinc-100 dark:bg-zinc-950'>
      <JsonLd<Schema.WebSite> item={defaultSchema} />
      {children}
      <BtnGoTop />
    </div>
  )
}